module.exports = __webpack_public_path__ + "static/media/TribTechLogo.c847d37b.png";